import React, { useState } from 'react';
import HowItWorks from '../UI/HowItsWorks';

const HowItWorksStructure = () => {
    

    const steps = [
        {
            number: 1,
            title: "Consultation & Project Brief ",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2FHOW_IT_WORKS_icon%2FConsultation_and_Project_Brief.png?alt=media&token=10c4b10e-098f-49be-ac5b-8d58f8122000",
            description: "Initial discussion about your project requirements and scope"
        },
        {
            number: 2,
            title: "3D Modeling & Design",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2FHOW_IT_WORKS_icon%2F3D_Modeling_and_Design.png?alt=media&token=f710958c-799c-4e41-a053-76e27cc8ec84",
            description: "Detailed cost estimation and portfolio presentation"
        },
        {
            number: 3,
            title: "Rendering & Animation",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2FHOW_IT_WORKS_icon%2FRendering_and_Animation.png?alt=media&token=5c5d544f-a231-46a1-8274-fd3dd1efd95b",
            
            description: "Schedule your project timeline"
        },
        {
            number: 4,
            title: "Client Review & Modification",
            icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2FHOW_IT_WORKS_icon%2FClient_Review_and_Modifications.png?alt=media&token=b82268b2-3168-4e81-bca6-d6d13aad8f12",
            
            description: "Comprehensive MEP system design and documentation"
        },
        {
            number: 5,
            title: "Final Delivery",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2FHOW_IT_WORKS_icon%2FFinal_Delivery.png?alt=media&token=f102570d-abc0-4dee-a337-4f60e6eef0c7",
            description: "Quality check and project delivery"
        }
    ];


    return (
        <><HowItWorks steps={steps}/></>
    );
};

export default HowItWorksStructure;
